import BookingForm from '../components/BookingForm';

export default function Booking() {
  return (
    <div className="container py-5">
      <div className="row g-4">
        <div className="col-12 col-lg-7">
          <h1 className="h2 fw-bold mb-3">Book a Ride</h1>
          <p className="text-secondary">Complete the form and dispatch will confirm during business hours.</p>
          <BookingForm />
        </div>
        <div className="col-12 col-lg-5">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Contact & Hours</h5>
              <ul className="list-unstyled mb-0">
                <li><strong>Phone:</strong> +1 (651) 283-7169</li>
                <li><strong>Email:</strong> info@bisitellatransport.com</li>
                <li><strong>Address:</strong> Saint Paul Minnesota 55116</li>
                <li><strong>Hours:</strong> 24/7</li>
              </ul>
              <div className="ratio ratio-16x9 mt-3">
                <iframe
                  title="Service Area Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509374!2d144.95565131590497!3d-37.81732774201119!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQ5JzAyLjQiUyAxNDTCsDU3JzI1LjQiRQ!5e0!3m2!1sen!2sus!4v1611813044755"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
